import { tickerValidator } from "../../../globalVariables";

export default {
  name: "Filter Options",
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "filterOptionTranslations",
  },
  sorting: {
    property: "filterOptionPosition",
    sortable: true,
  },
  reorder: true,
  fields: {
    list: [
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "active",
        displayName: "Is active?",
        widget: "singleSwitch",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "pattern",
        displayName: "Pattern",
      },
      {
        fieldName: "type",
        displayName: "Type",
      },
      {
        fieldName: "filterOptionPosition",
        displayName: "Order",
        sortProperty: true,
      },
    ],
    form: [
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "filterOptionPosition",
        widget: "hidden",
        defaultValue: 0,
      },
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Active",
        widget: "checkbox",
        description: "Is the option active?",
        helpText: "Check whether this option applies or not.",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        readOnly: true,
        widget: "input",
      },
      {
        fieldName: "pattern",
        displayName: "Pattern",
        widget: "input",
      },
      {
        fieldName: "type",
        displayName: "Type",
        widget: "selector",
        optionDisplay: {
          ESTABLISHMENT: {
            label: "Establishment",
          },
          INVENTORY: {
            label: "Inventory",
          },
          URL: {
            label: "URL",
          },
          PACKAGE: {
            label: "Package",
          },
          EXTRA: {
            label: "Extra",
          },
          INVENTORY_AND_PACKAGE: {
            label: "Inventory and packages",
          },
          ONLINE_STORE: {
            label: "Online Store",
          },
        },
        defaultValue: "ESTABLISHMENT",
      },
      {
        fieldName: "name",
        displayName: "Name",
        widget: "input",
        translated: true,
      },
      {
        fieldName: "description",
        displayName: "Description",
        widget: "textarea",
        translated: true,
      },
    ],
  },
  validation: {
    id: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    active: {
      type: "Boolean",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    ticker: tickerValidator,
    pattern: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    type: {
      type: "Enum",
      constraints: {
        inclusion: {
          within: [
            "ESTABLISHMENT",
            "INVENTORY",
            "URL",
            "PACKAGE",
            "EXTRA",
            "INVENTORY_AND_PACKAGE",
            "ONLINE_STORE",
          ],
        },
        presence: {
          allowEmpty: false,
        },
      },
      defaultValue: "ESTABLISHMENT",
    },
    filterOptionPosition: {
      type: "Number",
      constraints: {
        numericality: {
          greaterThanOrEqualTo: 0,
        },
        presence: {
          allowEmpty: false,
        },
      },
    },
    name: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    description: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
  },
};
